import { render, staticRenderFns } from "./AttendanceView.vue?vue&type=template&id=475ad02f&scoped=true"
import script from "./AttendanceView.vue?vue&type=script&lang=js"
export * from "./AttendanceView.vue?vue&type=script&lang=js"
import style0 from "./AttendanceView.vue?vue&type=style&index=0&id=475ad02f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ad02f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('475ad02f')) {
      api.createRecord('475ad02f', component.options)
    } else {
      api.reload('475ad02f', component.options)
    }
    module.hot.accept("./AttendanceView.vue?vue&type=template&id=475ad02f&scoped=true", function () {
      api.rerender('475ad02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/AttendanceView.vue"
export default component.exports